var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{staticClass:"upload-demo",attrs:{"auto-upload":false,"on-remove":_vm.remove,"on-change":_vm.onChange,"drag":"","limit":1,"on-exceed":_vm.handleExceed,"name":"filename0","file-list":_vm.fileList}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n      将文件拖到此处，或\n      "),_c('em',[_vm._v("点击上传")]),_vm._v("，大小不能超过 100MB\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f5704e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/attachment/um-attachment.vue
// module id = 52
// module chunks = 0